<script>
import { BButtonGroup, BDropdown, BDropdownItem, BDropdownDivider } from 'bootstrap-vue';
import { Confirm } from '../../services/Confirm';

export default {
  components: {
    BDropdown,
    BButtonGroup,
    BDropdownItem,
    BDropdownDivider,
  },

  created () {
    Bus.$on('loading', (loading) => this.loading = loading);
  },

  props: {
    segment: null,
    actions: {},
  },

  data () {
    return {
      loading: false,
      action: {},
      count: null,
    };
  },

  computed: {
    filteredActions () {
      ['mail.send', 'sms.send', 'integration.whatsapp.send', 'mail.notify', 'mail.notify_raw'].forEach((type) => {
        delete this.actions[type];
      });

      return this.actions;
    },
  },

  mounted () {
    this.getCount();
  },

  methods: {
    async deleteSegment () {
      if (! await Confirm(this.__('Deseja excluir a segmentação?'))) {
        return;
      }

      this.$http.delete(`/lead/segment/${this.segment.id}`)
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          Alert.error(this.__('Você não tem permissão para excluir esta segmentação.'));
        });
    },

    async deleteLeadsFromSegment () {
      if (this.count == 0) {
        return Alert.error(this.__('A segmentação não possui lead.'));
      }

      // const count = this.count > 1 ? `Total de leads: ${this.count} ` : '';

      const text = this.__('Os leads excluídos não poderão ser recuperados.');

      if (! await Confirm(this.__('Excluir leads da segmentação?'), text)) {
        return;
      }

      this.$http.delete(`/lead/from/segment/${this.segment.id}`)
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          Alert.error(this.__('Você não tem permissão para excluir os leads desta segmentação.'));
        });
    },

    async deleteLeadsNotFromSegment () {
      const text = this.__('Os leads excluídos não poderão ser recuperados.');

      if (! await Confirm(this.__('Deseja excluir TODOS os leads que NÃO estão nesta segmentação?'), text)) {
        return;
      }

      this.$http.delete(`/lead/not/from/segment/${this.segment.id}`)
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          Alert.error(this.__('Você não tem permissão para excluir os leads fora desta segmentação.'));
        });
    },

    selectAction (action, type) {
      action.type = type;

      Bus.$emit('SegmentActionSelected', [action, this.segment]);
    },

    getCount () {
      this.$http.get(`/lead/segment/${this.segment.id}/count`)
        .then((response) => {
          this.count = response.data;
        })
        .catch(() => {
        });
    },
  },
};
</script>

<template>
  <div>
    <BButtonGroup
      class="dropdown"
    >
      <BDropdown
        no-caret
        variant="link"
        class="nav-action nav-profile"
        toggle-class="text-decoration-none p-0"
        menu-class="bdk-segment-actions__dropdown"
        
      >
        <template #button-content>
          <button
            type="button"
            aria-haspopup="true"
            aria-expanded="false"
            class="segment-actions"
          >
            <i
              class="fa fa-angle-down pr-1"
            />

            {{ __('Ações') }}

            <i
              class="fa fa-circle-o-notch fa-spin"
              v-if="loading"
            />
          </button>
        </template>

        <template
          v-if="! loading"
        >
          <BDropdownItem
            href="#"
            @click.prevent="deleteSegment()"
          >
            {{ __('Excluir segmentação') }}
          </BDropdownItem>

          <BDropdownItem
            href="#"
            @click.prevent="deleteLeadsFromSegment()"
          >
            {{ __('Excluir leads que estão nessa segmentação') }}
          </BDropdownItem>

          <BDropdownItem
            href="#"
            @click.prevent="deleteLeadsNotFromSegment()"
          >
            {{ __('Excluir leads fora desta segmentação') }}
          </BDropdownItem>
        </template>

        <BDropdownDivider/>

        <template
          v-if="actions"
        >
          <BDropdownItem
            href="#"
            :key="action.name"
            v-for="(action, type) in filteredActions"
            @click.prevent="selectAction(action, type)"
          >
            {{ __(action.name) }}
          </BDropdownItem>
        </template>
      </BDropdown>
    </BButtonGroup>
  </div>
</template>

<style lang="scss" scoped>
  @import "../../../sass/variables";

  .segment-actions {
    border-radius: 14px;
    border: 0;
    outline: 1px solid $salesflow-outline-gray-medium;
    background-color: $salesflow-outline-gray-light;
    width: 84px;
    height: 30px;
    font-size: 0.75rem;
  }

  ::v-deep .dropdown-menu {
    max-height: 200px;
    margin: 8px 48px;
  }

  a:hover {
    text-decoration: none;
  }
</style>
